import { render, staticRenderFns } from "./sto-buy1.vue?vue&type=template&id=1bd68cb4&"
import script from "./sto-buy1.vue?vue&type=script&lang=js&"
export * from "./sto-buy1.vue?vue&type=script&lang=js&"
import style0 from "./sto-buy1.vue?vue&type=style&index=0&id=1bd68cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports